// Google Analytics 4 утилита для Main-Bet
// Замените 'G-XXXXXXXXXX' на ваш реальный Measurement ID

const GA_MEASUREMENT_ID = 'G-4Y31KJ8FGC'; // Замените на ваш ID

// Инициализация Google Analytics
export const initGA = () => {
  // Проверяем, что мы в браузере и GA еще не загружен
  if (typeof window === 'undefined' || window.gtag) {
    return;
  }

  // Создаем скрипт для загрузки GA
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Инициализируем gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };

  // Конфигурируем GA
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_title: document.title,
    page_location: window.location.href,
    // Отключаем автоматическое отслеживание страниц для SPA
    send_page_view: false
  });

  console.log('Google Analytics initialized');
};

// Отслеживание просмотров страниц
export const trackPageView = (path, title) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href
  });

  console.log('GA: Page view tracked:', path);
};

// Отслеживание времени на сайте (для новых посетителей)
export const trackNewVisitor = () => {
  // Проверяем, первый ли это визит
  const isFirstVisit = !localStorage.getItem('main_bet_visited');
  
  if (isFirstVisit) {
    localStorage.setItem('main_bet_visited', 'true');
    
    // Отслеживаем через 15 секунд (как в оригинальном коде)
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'new_visitor', {
          event_category: 'user_behavior',
          event_label: window.location.pathname
        });
      }
    }, 15000);
  }
};

// Отслеживание событий
export const trackEvent = (eventName, category = 'button_click') => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', eventName, {
    event_category: category
  });
};

// Отслеживание просмотра прогнозов с дополнительными данными
export const trackPredictionView = (prediction) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'prediction_view', {
    event_category: 'content',
    event_label: `${prediction.homeTeam} vs ${prediction.awayTeam}`,
    custom_parameters: {
      confidence: prediction.confidence,
      tip: prediction.tip,
      match_date: prediction.matchDate,
      league: prediction.league || 'unknown'
    }
  });
};

// Отслеживание просмотра гайдов
export const trackGuideView = (guide) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'guide_view', {
    event_category: 'content',
    event_label: guide.title,
    custom_parameters: {
      category: guide.category,
      author: guide.author,
      reading_time: Math.ceil(guide.content?.replace(/<[^>]*>/g, '').split(' ').length / 200)
    }
  });
};

// Отслеживание просмотра бонусов
export const trackBonusView = (bonus) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'bonus_view', {
    event_category: 'content',
    event_label: bonus.title,
    custom_parameters: {
      bookmaker: bonus.bookmaker,
      amount: bonus.amount,
      wagering: bonus.wagering,
      bonus_type: bonus.type || 'welcome'
    }
  });
};

// Отслеживание переходов на букмекерские сайты
export const trackBookmakerClick = (bookmaker, source = 'bonus') => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'bookmaker_click', {
    event_category: 'outbound_link',
    event_label: bookmaker,
    custom_parameters: {
      source: source,
      value: 1
    }
  });
};

// Отслеживание действий с коэффициентами
export const trackOddsInteraction = (action, prediction) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'odds_interaction', {
    event_category: 'betting',
    event_label: `${prediction.homeTeam} vs ${prediction.awayTeam}`,
    custom_parameters: {
      action: action, // 'view', 'click', 'copy'
      home_odds: prediction.odds?.home,
      draw_odds: prediction.odds?.draw,
      away_odds: prediction.odds?.away
    }
  });
};

// Отслеживание использования промокодов
export const trackPromoCodeAction = (action, code, bookmaker) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'promo_code_action', {
    event_category: 'engagement',
    event_label: bookmaker,
    custom_parameters: {
      action: action, // 'view', 'copy', 'click'
      promo_code: code
    }
  });
};

// Улучшенное отслеживание конверсий для структурированных данных
export const trackConversion = (type, data) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'conversion', {
    event_category: 'conversion',
    event_label: type,
    value: 1,
    custom_parameters: data
  });
};

const analytics = {
  initGA,
  trackPageView,
  trackNewVisitor,
  trackEvent,
  trackPredictionView,
  trackGuideView,
  trackBonusView,
  trackBookmakerClick,
  trackOddsInteraction,
  trackPromoCodeAction,
  trackConversion
};

export default analytics; 